import React from 'react';

export default function SiteFooter() {
  return (
    <footer className="site-footer">
      <a href="/operators/myciti">MyCiTi</a>
      <a href="/operators/golden-arrow">Golden Arrow</a>
      <a href="/areas">Areas</a>
      <a href="/saved-timetables">Saved</a>
      <a href="/about">About</a>
      <a href="/contact">Contact</a>
      <a href="/privacy-policy">Privacy Policy</a>
      <a href="/terms">Terms</a>
    </footer>
  );
}
